exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\r\n    display: flex;\r\n    align-items: center;\r\n    background-color: #8600b5;\r\n    height: 60px;\r\n    margin-top: 10px;\r\n    margin-bottom: 3px;\r\n    padding-left: 20px;\r\n    font-size: 26px;\r\n    color: #fff;\r\n    flex-grow: 0;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.panel-buttons {\r\n    margin-left: auto;\r\n    display: flex;\r\n}\r\n\r\n.headerfont {\r\n    color: #fff;\r\n    font-size: 26px;\r\n    font-weight: 400;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.headerfontbold {\r\n    color: #fff;\r\n    font-size: 26px;\r\n    font-weight: 700;\r\n    text-transform: uppercase;\r\n}\r\n\r\n.breadcrumSpacer {\r\n    color: #fff;\r\n    font-size: 20px;\r\n    font-weight: 400;\r\n    margin-left: 15px;\r\n    margin-right: 15px;\r\n}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./Scripts/fw/breadcrum/breadcrum.component.css
// module id = 2146
// module chunks = 1